import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

export default function CronJobs() {
  return (
    <PagedWorkloadPage
      title="CronJobs" kind="CronJob" resource="cronjobs" label="cronjobs"
      deletable
      cols={['Name', 'Namespace', 'Schedule', 'Suspended', 'Last Schedule', 'Age']}
      renderRow={c => [
        <td key="n"><Code>{c.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{c.namespace}</td>,
        <td key="s"><Code>{c.schedule}</Code></td>,
        // A suspended CronJob never fires — worth flagging in red, not as a bare "Yes".
        <td key="su">{c.suspend
          ? <span style={{ color: 'var(--color-danger-500)' }}>Yes</span>
          : '—'}</td>,
        <td key="l"><Age ts={c.last_schedule} /></td>,
        <td key="a"><Age ts={c.created_at} /></td>,
      ]}
    />
  );
}
